// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";

import Navigation from "./components/Navigation";
import RouteConfig from "./RouteConfig";
import Footer from "./components/Footer";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("auth") === "true"
  ); // Check if user is logged in

  // Handle login
  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("auth", "true"); // Store authentication status
  };

  // Handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("auth"); // Remove authentication status
  };

  return (
    <Router>
      <Navigation isAuthenticated={isAuthenticated} onLogout={handleLogout} />
      <div>
        <RouteConfig isAuthenticated={isAuthenticated} onLogin={handleLogin} />
      </div>
      <Footer /> {/* Include Footer */}
    </Router>
  );
}

export default App;
